module.exports = __webpack_public_path__ + "static/pintura-5349ce57205825fd28fc06a1cdb10113.jpg";